import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { fail } from 'features/toast/Toast'
import { DashboardTypeNames } from 'features/dashboard/utils/hooks/useDashboardTypeName'
import { hideBackDrop, showBackDrop } from 'features/dialog/backDropSlice'
import { downloadCsvFile } from 'utils'
import api from 'api/axios/foka'
import NoneAnchor from 'components/NoneAnchor'
import { DashboardTypes } from 'features/Codes'
import Icon from 'components/Icon'
import Button from 'components/form/Button'

const KeywordDownloadButton = () => {
  const dispatch = useDispatch()
  const type = DashboardTypes.KEYWORD
  const name = DashboardTypeNames[type]
  const {
    common: { from, to },
    filter: { filters },
    table: {
      campaignTable: { selectedIds: campaignIds },
      adGroupTable: { selectedIds: adGroupIds },
      keywordTable: { totalElements, sort },
      config: {
        columns: { [type]: columns },
      },
    },
  } = useSelector(state => state.dashboard, shallowEqual)
  const { name: adAccountName } = useSelector(state => state.account.current)
  const handleKeywordTableDownload = async includeQualityScore => {
    if (totalElements === 0) {
      fail('다운로드할 데이터가 없습니다.')
    } else {
      dispatch(showBackDrop())
      try {
        const response = await api.dashboard.downloadKeywordTable({
          from,
          to,
          sort,
          filters,
          dashboardColumns: columns,
          campaignIds,
          adGroupIds,
          includeQualityScore,
        })
        downloadCsvFile(
          response.data,
          `${adAccountName}_${name}_${from}_${to}.csv`
        )
      } catch (e) {
        fail('알 수 없는 에러가 발생했습니다.')
      }
      dispatch(hideBackDrop())
    }
  }
  return (
    <div className="wrap_download">
      <Button line icon>
        <Icon name="download">다운로드</Icon>
      </Button>
      <div className="download_option">
        <div className="option_group">
          <ul className="list_download">
            <li>
              <NoneAnchor
                className="link_download"
                onClick={() => handleKeywordTableDownload(false)}
                data-tiara-action-name="키워드탭_다운로드_품질지수제외_클릭">
                <Icon name="arrow" />
                품질지수 제외<Icon name="download">다운로드</Icon>
              </NoneAnchor>
              <div className="desc_download">
                품질지수가 모두 0으로 나타나며 다운로드 속도가 빠릅니다.
              </div>
            </li>
            <li>
              <NoneAnchor
                className="link_download"
                onClick={() => handleKeywordTableDownload(true)}
                data-tiara-action-name="키워드탭_다운로드_품질지수포함_클릭">
                <Icon name="arrow" />
                품질지수 포함<Icon name="download">다운로드</Icon>
              </NoneAnchor>
              <div className="desc_download">
                다운로드시 품질지수가 포함되어 몇분의 시간이 소요될 수 있습니다.
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
export default KeywordDownloadButton
